import { TransferRequestImportPage } from "@/features/transfer-request/pages/TransferRequestImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-request/import")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["transfer_request.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: TransferRequestImportPage,
});
